import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=03210ef6&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03210ef6')) {
      api.createRecord('03210ef6', component.options)
    } else {
      api.reload('03210ef6', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=03210ef6&", function () {
      api.rerender('03210ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/stock-adjustment/DetailPage.vue"
export default component.exports